import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import store from '../store';

const renderWrapper = (Component, props = {}) =>
  global.window ? (
    <ThemeProvider theme={Themes[global.ThemeName]}>
      <Provider store={store}>
        <Component {...props} />
      </Provider>
    </ThemeProvider>
  ) : (
    <Provider store={global.LitiumReduxStore}>
      <Component {...props} />
    </Provider>
  );

export default renderWrapper;
